export default __webpack_public_path__ + "static/media/fuelEnDetailRoundMobile.ee657678.jpg";